import type { Booking, BookingCalendarMonth } from '../types';
import { api } from './http';

export const getUpcomingBookings = () => api.get<Booking[]>('/bookings/upcoming');
export const getBookingCalendar = (year: number, month: number) =>
  api.get<BookingCalendarMonth>('/bookings/calendar', { params: { year, month } });
export const addBooking = (data: { user_id: number; date_from: string; date_to: string }) =>
  api.post<Booking>('/bookings', null, { params: data });
export const updateBookingStatus = (booking_id: number, status: string) =>
  api.put<{ updated: boolean }>(`/bookings/${booking_id}`, null, { params: { status } });
